import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.602 3.147c.266 1.354-.397 2.625-1.48 2.838-1.084.214-2.179-.712-2.445-2.067-.266-1.355.396-2.626 1.48-2.839 1.084-.213 2.178.713 2.445 2.068Zm4.805.772c.267-1.355-.396-2.626-1.48-2.84-1.084-.212-2.178.713-2.445 2.068-.266 1.355.397 2.626 1.48 2.839 1.084.213 2.179-.712 2.445-2.067ZM3.14 8.276c.717-.414.85-1.526.298-2.482-.552-.957-1.581-1.397-2.299-.982C.422 5.226.288 6.337.84 7.294c.552.956 1.582 1.396 2.3.982Zm9.422-2.482c-.552.956-.418 2.068.299 2.482.717.414 1.747-.026 2.299-.982.552-.957.418-2.068-.299-2.482-.718-.414-1.747.025-2.3.982Zm-9.872 5.21 2.132-2.787c1.601-2.094 4.754-2.094 6.355 0l1.947 2.544a2.588 2.588 0 0 1-3.34 3.82l-.855-.489a2 2 0 0 0-1.886-.052l-1.304.652a2.455 2.455 0 0 1-3.048-3.688Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructurePet16 = createIcon(IconComponent);